import appConfig from "../config/app.config";
import { makePostRequest , makeDeleteRequest} from '../services/makeRequest.js';
import { setUser } from "../libs/user";

const mergeUsersService = async (body, authToken) => {
  const response = await makePostRequest(
    `${appConfig.apiUrl.mergeUsers}`,
    body,
    {Authorization: `Bearer ${authToken}`}
  );
  setUser(response.data)
  return response.data;
};
const verifyOtpMergeSevice = async (body,authToken) => {
  const response = await makePostRequest(
    `${appConfig.apiUrl.sendOtpMerge}`,
    body,
    {Authorization: `Bearer ${authToken}`}
  );
  return response.data;
};

const resendOtpMergeSevice = async (body, authToken) => {
  const response = await makePostRequest(`${appConfig.apiUrl.resendOtpMerge}`,
    body,
    {Authorization: `Bearer ${authToken}`}
  );
  return response.data;
};

const mergeUsersLogoutService = async (authToken) => {
  const response = await makeDeleteRequest(`${appConfig.apiUrl.mergeUsersLogout}`,
    {Authorization: `Bearer ${authToken}`}
  );
  return response.data;
};

export { mergeUsersService, verifyOtpMergeSevice , resendOtpMergeSevice, mergeUsersLogoutService};
